import React from 'react';
import PropTypes from 'prop-types';

import Title from '../Title';

import messages from './messages';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    const { hasError } = props || {};

    this.state = { hasError };
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <Title size="2" testId="qa-error-placeholder" message={messages.somethingWentWrong} />;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  // eslint-disable-next-line react/no-unused-prop-types
  hasError: PropTypes.bool
};

export default ErrorBoundary;
